import HEditor from "./src/index.vue";
export default HEditor;